import { useEffect, useState } from 'react'

export const useMatchMedia = (query: string): boolean => {
  const [doMatch, setDoMatch] = useState(window.matchMedia(query).matches)

  useEffect(() => {
    const media = window.matchMedia(query)
    if (media.matches !== doMatch) {
      setDoMatch(media.matches)
    }

    const listener = (): void => setDoMatch(media.matches)
    media.addEventListener('change', listener)
  }, [query])

  return doMatch
}
